<template>
  
  <div class="dashboard">
    <div class="row gx-4 gy-4 mb-2">
      <div :class="['col-md-6', 'mt-0', 'd-flex', { 'flex-column justify-items-center': fulcrumApp.status != '' && fulcrumApp.status != 'complete', 'align-items-center': fulcrumApp.status == 'complete' }]">
        <div class="d-flex align-items-center">
          <div v-if="fulcrumApp.lastSync || fulcrumApp.updatedAt" class="dashboard-last-sync"><strong>{{  h$.formatDate.full(fulcrumApp.lastSync || fulcrumApp.updatedAt, true) }}</strong> Last Refresh</div>
          <div :class="[{ 'label-success': fulcrumApp.status == 'ongoing' }, { 'label-default': fulcrumApp.status == 'complete' }, 'ms-2']">{{  fulcrumApp.status == 'ongoing' ? 'on-going' : 'completed' }}</div>
        </div>
        <div v-if="fulcrumApp.status != '' && fulcrumApp.status != 'complete'" class="dashboard-disclaimer mt-1 d-flex align-items-center">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-fill-warning me-1">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13V8ZM12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17H12.01C12.5623 17 13.01 16.5523 13.01 16C13.01 15.4477 12.5623 15 12.01 15H12Z"/>
          </svg> 
          <div>Project currently on-going, data is subject to change and not finalized until after review.</div>
        </div>
      </div>
      <div class="col-md-6 mt-0 d-flex text-end justify-content-end align-items-center">
        <div class="dashboard-card-toggle btn-group">
          <button :class="['btn btn-info', {'btn-inverse-info': dataViewMode == 'data'}]" @click.prevent="toggleViewMode('general')" style="width: 150px; justify-content: center;">Summary View</button>
          <button :class="['btn btn-info', {'btn-inverse-info': dataViewMode == 'general'}]" @click.prevent="toggleViewMode('data')" style="width: 150px; justify-content: center;">Detail Data View</button>
        </div>
        <a v-if="policyUpdate" title="Edit Project" class="btn-expandable btn-expandable-edit ms-2" :href="fulcrumAppEditUrl">
          <span class="icon" data-icon="edit"></span>
        </a>
      </div>
    </div>
    <div class="dashboard-progress mb-2">
      <div class="progress">
        <div class="progress-bar progress-bar-success" :style="{ opacity: isProgressVisible ? 1 : 0, width: progress + '%' }"></div>
      </div>
    </div>

    <component
      v-if="dataViewMode === 'general'"
      v-bind:is="'DashboardHighView' + this.dashboardType"
      :key="dataViewKey"
      ref="highView"
      :app="fulcrumApp"
      :data="assets"
      :google-map-api-key="googleMapApiKey"
      :policy-update="policyUpdate"
      @dataGroupApproved="onDataGroupApproved"
    />

    <component 
      v-if="dataViewMode === 'data'"
      v-bind:is="'DashboardDataView' + this.dashboardType"
      :key="dataViewKey"
      ref="dataView"
      :app="fulcrumApp"
      :data="assets"
      :google-map-api-key="googleMapApiKey"
      :policy-update="policyUpdate"
    ></component>

  </div>
</template>

<script>
import DashboardHighViewWoodPoles from "./high_view/screen_wood_poles";
import DashboardHighViewPadmounts from "./high_view/screen_padmounts";

import DashboardDataViewWoodPoles from "./data_view/screen_wood_poles"
import DashboardDataViewPadmounts from "./data_view/screen_padmounts"

import Helpers from "../../helpers.js";

export default {
  components: {
    DashboardHighViewWoodPoles,
    DashboardHighViewPadmounts,

    DashboardDataViewWoodPoles,
    DashboardDataViewPadmounts
  },

  props: {
    formId: String,
    appId: String,
    appDashboardType: String,
    googleMapApiKey: String,
    policyUpdate: Boolean
  },

  data: function () {
    return {
      fulcrumApp: {
        name: '',
        statusField: {},
        fields: [],
        dashboardGroups: [],
        dashboardDataFields: [
          "_record_id",
          "_title",
          "_latitude",
          "_longitude",
          "_status",
          "inspection_date", 
          "comment_summary",
          "nearest_address",
          "_created_by_name", 
          "initial_inspection_inspector",
          "can_reinforce",
          "maintenance_issues"
        ],
        lastSync: '',
        updatedAt: '',
        status: ''
      },

      assets: [],

      dashboardType: '',
      dashboardTypes: {
        wood_poles: 'WoodPoles',
        padmounts: 'Padmounts'
      },

      dataViewMode: '',
      dataViewKey: 0,

      isLoaded: false,
      isProgressVisible: false,
      progress: 0,
    }
  },

  setup () {
    return {
      h$: Helpers
    }
  },

  created: function() {
    const params = new URLSearchParams(window.location.search);
    const viewParam = params.get('view');

    this.dataViewMode = (viewParam === 'data') ? 'data' : 'general';
    this.dashboardType = this.dashboardTypes[this.appDashboardType] || this.dashboardTypes['wood_poles'];
  },

  mounted: function() {
    this.fetchData();
  },

  computed: {
    fulcrumAppEditUrl() {
      return `/project_dashboards/${this.fulcrumApp.id}/edit`;
    }
  },

  methods: {
    onDataGroupApproved({ groupType, groupName }) {
      this.assets = this.assets.map((asset) => {
        if (asset[groupType] !== groupName) {
          return asset;
        }

        const updatedAsset = {
          ...asset,
          approved: true
        };

        return updatedAsset;
      });
    },

    toggleViewMode(mode) {
      this.dataViewMode = mode;

      // Update the 'view' query string in the URL
      const params = new URLSearchParams(window.location.search);
      params.set('view', mode);

      // Clear filter params on view mode switch
      params.delete('v-filter');

      const newUrl = window.location.pathname + '?' + params.toString();
      window.history.replaceState({}, '', newUrl);

      // Increment the data view key to mount child components on mode change
      this.dataViewKey++;

      // Close details pane if open
      if (vmDetailsPane && vmDetailsPane.$refs.detailsPane) {
        vmDetailsPane.$refs.detailsPane.close();
      }
    },

    fetchData() {
      app.graphql.get(
        "details.fulcrumApp",

        {
          filter: {
            formId: this.formId
          }
        },

        (data) => {
          // Set App Data
          let fulcrumApp = data.data.fulcrumApps.edges[0].node;

          fulcrumApp.statusField = JSON.parse(fulcrumApp.statusField) || {};
          fulcrumApp.fields = fulcrumApp.fields.map((field) => {return JSON.parse(field) });

          fulcrumApp.dashboardGroups = fulcrumApp.dashboardGroups.map(name => {
            const field = fulcrumApp.fields.find(item => item.data_name === name);
            
            return field ? { 'data_name': name, 'label': field.label } : { 'data_name': name, 'label': name };
          });

          // Wood Poles
          const dashboardDataFieldsWoodPoles = [
            "inspection_type",
            "manufacturer",
            "species",
            "class",
            "length",
            "damagedecay_present",
            "year",
            "pole_number",
            "rejected_pole",
            "priority_pole",
          ]

          // Padmounts
          const dashboardDataFieldsPadmounts = [
            "facility_id",
            "pad_inspection_type",
            "cabinet_corrosion",
            "cabinet_dent",
            "cabinet_erosion",
            "cabinet_leaking_oil",
            "pad_pad_issues",
            "pad_pad_issues_hole_size",
            "pad_pad_issues_number_of_holes",
            "padmount_issues",
            "ground_mounted_equipment_type"
          ]

          // Include all photo fields
          const photoFields = fulcrumApp.fields
            .map((field) => field.data_name)
            .filter((name) => /_photos?$/.test(name))
          
          // Ensure dashboard data fields include type specific fields based on dashboard type
          const typeSpecificFields = this.dashboardType === 'WoodPoles'
            ? dashboardDataFieldsWoodPoles
            : dashboardDataFieldsPadmounts;
          const baseDashboardDataFields = Array.isArray(this.fulcrumApp.dashboardDataFields)
            ? this.fulcrumApp.dashboardDataFields
            : [];
          fulcrumApp.dashboardDataFields = Array.from(new Set([
            ...baseDashboardDataFields,
            ...typeSpecificFields,
            ...photoFields
          ]));

          this.fulcrumApp = fulcrumApp;

          // Fetch Dashboard Data
          this.fetchDashboard()
        },

        (error) => {
          app.ui.toast.add({
            priority: "danger",
            title : "Project Details",
            message : "Something went wrong! Project cannot be found or doesn't exist!"
          })
        }
      );
    },
 
    fetchDashboard: function() {
      const dashboardGroups = this.fulcrumApp.dashboardGroups.map(item => item.data_name);
      const dashboardDataFields = this.fulcrumApp.dashboardDataFields;

      let assets = [];

      let fetchParams = {
        appID: this.appId,
        pageSize: 10000,
        dataFields: [
          ...dashboardDataFields,
          ...dashboardGroups
        ]
      };

      let currentPage = 1;

      let fetch = (cursor, success) => {
        fetchParams.cursor = cursor;

        app.graphql.get("dashboard.fulcrum.data",
          fetchParams,

          (data) => {
            let fulcrumRecords = data.data.fulcrumRecords,
                pageInfo = fulcrumRecords.pageInfo;

            success(fulcrumRecords, pageInfo);
          },

          (error) => {
            app.ui.toast.add({
              priority: "danger",
              title: "Something went wrong!",
              message: "Unable to fetch Dashboard records!"
            });
          }
        )
      };

      let getRecords = (cursor) => {
        fetch(
          cursor,

          (fulcrumRecords, pageInfo) => {
            if (fulcrumRecords.totalCount > 0) {
              // store assets data on every fetch
              fulcrumRecords.edges.forEach((edge) => {
                let asset = JSON.parse(edge.node.data) || null;

                if (asset) {
                  asset.recordID = edge.node.id;
                  asset.approved = edge.node.approved;

                  assets.push(asset);
                }
              });

              // set progress bar
              if (fulcrumRecords.totalPageCount > 1) {
                this.isProgressVisible = true;
                this.progress = currentPage / fulcrumRecords.totalPageCount * 100;

                currentPage++;
              }

              // fetch next page
              if (pageInfo.hasNextPage && pageInfo.endCursor) {
                Promise.resolve(getRecords(pageInfo.endCursor));
              }
              
              // set dashboard data
              if(!pageInfo.hasNextPage) {
                this.progress = 100;
                this.isLoaded = true;

                setTimeout(() => {
                  this.isProgressVisible = false;
                  this.progress = 0;

                  this.assets = assets;
                }, 1000);
              }
            }
          }
        );
      };

      getRecords(window.btoa(0));
    }
  },
}
</script>
